"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _defaultTab = _interopRequireDefault(require("./defaultTab"));

var WidgetTab = function WidgetTab(props) {
  return /*#__PURE__*/_react["default"].createElement(_defaultTab["default"], (0, _extends2["default"])({}, props, {
    leftAligned: true,
    noBorderBottomTab: true,
    navLinkClass: "oui-nav-link-widget",
    navItemClass: "oui-nav-item-widget"
  }));
};

var _default = WidgetTab;
exports["default"] = _default;